<template>
  <div :id="name" v-show="visible">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    indicator: [Number, String]
  },

  computed: {
    visible() {
      return this.$parent.active == this.name;
    }
  }
};
</script>